import Header from '@/components/HeaderDashboard.vue';
import Sidebar from '@/components/Sidebar.vue';
import SalesChart from '@/components/SalesChart.vue';
import { ref } from 'vue';
export default {
    name: 'Dashboard',
    components: {
        Header,
        Sidebar,
        SalesChart,
    },
    setup() {
        const view = ref('orders'); // default view
        return {
            view,
        };
    },
};
